"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _airbnbPropTypes = require("airbnb-prop-types");

var _styler = _interopRequireDefault(require("../Styler/styler"));

var _clickOutside = _interopRequireDefault(require("../ClickOutside/clickOutside"));

var _popupWrapper = _interopRequireDefault(require("./popupWrapper"));

var _popupHeader = _interopRequireDefault(require("./popupHeader"));

var _popupContent = _interopRequireDefault(require("./popupContent"));

var _popupFooter = _interopRequireDefault(require("./popupFooter"));

var _popupWindow = _interopRequireDefault(require("./popupWindow"));

var _positioningHelper = require("../helpers/positioning-helper");

var _portal = require("../Portal/portal");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var PopupTarget = _react.default.forwardRef(function (props, ref) {
  var triggerStyles = ['co-popup__wrapper__target'];

  var children = props.children,
      active = props.active,
      eventProps = _objectWithoutProperties(props, ["children", "active"]);

  var allowedModifiers = {
    active: active
  };
  return _react.default.createElement(_styler.default, {
    classNames: triggerStyles,
    modifiers: allowedModifiers
  }, function (styles) {
    return _react.default.createElement("div", _extends({
      ref: ref,
      className: styles
    }, eventProps), children);
  });
});

var Popup =
/*#__PURE__*/
function (_React$Component) {
  _inherits(Popup, _React$Component);

  function Popup(props) {
    var _this;

    _classCallCheck(this, Popup);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Popup).call(this, props));

    _defineProperty(_assertThisInitialized(_this), "onTargetEvent", function (onToggle) {
      return function (event) {
        event.stopPropagation();
        event.preventDefault();
        var nestedElements = (0, _positioningHelper.getNestedElements)(event);
        if (nestedElements.length) _this.container = nestedElements[0];
        onToggle(event);
      };
    });

    _defineProperty(_assertThisInitialized(_this), "onClickOutside", function (e) {
      var path = e.path || e.composedPath && e.composedPath();
      var isInPortal = path.includes(_this.portal);
      var isInContainer = path.includes(_this.container);
      var isInTarget = path.includes(_this.target.current);

      if (isInTarget) {
        e.stopPropagation();
        e.preventDefault();
      }

      if (isInPortal === isInContainer && _this.props.open) _this.props.onToggle(e);
    });

    _this.target = _react.default.createRef();
    _this.container = null;
    _this.componentName = 'popup';
    _this.portal = (0, _portal.createPortalContainer)(_this.componentName);
    _this.state = {
      hasRef: false
    };
    return _this;
  }

  _createClass(Popup, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.target.current && !this.state.hasRef) this.setState({
        hasRef: true
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          useOver = _this$props.useOver,
          open = _this$props.open,
          target = _this$props.target,
          onToggle = _this$props.onToggle,
          children = _this$props.children;
      var onEvent = this.onTargetEvent(onToggle);
      var eventProps = useOver ? {
        onMouseEnter: onEvent,
        onMouseLeave: onEvent
      } : {
        onClickCapture: onEvent
      };
      return _react.default.createElement(_react.default.Fragment, null, _react.default.createElement(PopupTarget, _extends({
        ref: this.target,
        active: open
      }, eventProps), target), _react.default.createElement(_clickOutside.default, {
        onClickOutside: this.onClickOutside
      }, this.target.current && this.portal && open ? _react.default.createElement(_popupWindow.default, _extends({}, this.props, {
        componentName: this.componentName,
        close: onToggle,
        visible: open,
        target: this.target.current,
        container: this.container || this.target.current
      }), children) : null));
    }
  }]);

  return Popup;
}(_react.default.Component);

var sizeProps = (0, _airbnbPropTypes.mutuallyExclusiveTrueProps)('small', 'large');
Popup.defaultProps = {
  position: _positioningHelper.LEFT_BOTTOM
};
Popup.propTypes = {
  /** {---}
   *  Sequence of:
   *    @@<Popup.Header>@@ (optional, max: 1),
   *    @@<Popup.Content>@@ (required, max: 1),
   *    @@<Popup.Footer>@@ (optional, max: 1) */
  children: _propTypes.any.isRequired,

  /** {const}
   *  One of:
   *    @@Popup.POSITION_LEFT_TOP@@
   *    @@Popup.POSITION_CENTER_TOP@@
   *    @@Popup.POSITION_RIGHT_TOP@@
   *    @@Popup.POSITION_LEFT_CENTER@@
   *    @@Popup.POSITION_RIGHT_CENTER@@
   *    @@Popup.POSITION_LEFT_BOTTOM@@
   *    @@Popup.POSITION_CENTER_BOTTOM@@
   *    @@Popup.POSITION_RIGHT_BOTTOM@@ */
  position: (0, _propTypes.oneOf)([_positioningHelper.LEFT_TOP, _positioningHelper.CENTER_TOP, _positioningHelper.RIGHT_TOP, _positioningHelper.LEFT_CENTER, _positioningHelper.RIGHT_CENTER, _positioningHelper.LEFT_BOTTOM, _positioningHelper.CENTER_BOTTOM, _positioningHelper.RIGHT_BOTTOM]),
  fluid: _propTypes.bool,
  useOver: _propTypes.bool,
  open: _propTypes.bool,
  target: _propTypes.node.isRequired,
  onToggle: _propTypes.func.isRequired,
  inverted: _propTypes.bool,
  scrollable: _propTypes.bool,

  /** {bool} Mutually exclusive props: @@small@@ @@large@@ */
  small: sizeProps,

  /** {bool} Mutually exclusive props: @@small@@ @@large@@ */
  large: sizeProps
};
Popup.POSITION_LEFT_TOP = _positioningHelper.LEFT_TOP;
Popup.POSITION_CENTER_TOP = _positioningHelper.CENTER_TOP;
Popup.POSITION_RIGHT_TOP = _positioningHelper.RIGHT_TOP;
Popup.POSITION_LEFT_CENTER = _positioningHelper.LEFT_CENTER;
Popup.POSITION_RIGHT_CENTER = _positioningHelper.RIGHT_CENTER;
Popup.POSITION_LEFT_BOTTOM = _positioningHelper.LEFT_BOTTOM;
Popup.POSITION_CENTER_BOTTOM = _positioningHelper.CENTER_BOTTOM;
Popup.POSITION_RIGHT_BOTTOM = _positioningHelper.RIGHT_BOTTOM;
Popup.Wrapper = _popupWrapper.default;
Popup.Header = _popupHeader.default;
Popup.Content = _popupContent.default;
Popup.Footer = _popupFooter.default;
Popup.Target = PopupTarget;
var _default = Popup;
exports.default = _default;
Popup.__docgenInfo = {
  "description": "",
  "methods": [{
    "name": "onTargetEvent",
    "docblock": null,
    "modifiers": [],
    "params": [{
      "name": "onToggle",
      "type": null
    }],
    "returns": null
  }, {
    "name": "onClickOutside",
    "docblock": null,
    "modifiers": [],
    "params": [{
      "name": "e",
      "type": null
    }],
    "returns": null
  }],
  "displayName": "Popup",
  "props": {
    "position": {
      "defaultValue": {
        "value": "LEFT_BOTTOM",
        "computed": true
      },
      "type": {
        "name": "enum",
        "value": [{
          "value": "import {\n  LEFT_TOP,\n  CENTER_TOP,\n  RIGHT_TOP,\n  LEFT_CENTER,\n  RIGHT_CENTER,\n  LEFT_BOTTOM,\n  CENTER_BOTTOM,\n  RIGHT_BOTTOM,\n  getNestedElements } from '../helpers/positioning-helper'",
          "computed": true
        }, {
          "value": "import {\n  LEFT_TOP,\n  CENTER_TOP,\n  RIGHT_TOP,\n  LEFT_CENTER,\n  RIGHT_CENTER,\n  LEFT_BOTTOM,\n  CENTER_BOTTOM,\n  RIGHT_BOTTOM,\n  getNestedElements } from '../helpers/positioning-helper'",
          "computed": true
        }, {
          "value": "import {\n  LEFT_TOP,\n  CENTER_TOP,\n  RIGHT_TOP,\n  LEFT_CENTER,\n  RIGHT_CENTER,\n  LEFT_BOTTOM,\n  CENTER_BOTTOM,\n  RIGHT_BOTTOM,\n  getNestedElements } from '../helpers/positioning-helper'",
          "computed": true
        }, {
          "value": "import {\n  LEFT_TOP,\n  CENTER_TOP,\n  RIGHT_TOP,\n  LEFT_CENTER,\n  RIGHT_CENTER,\n  LEFT_BOTTOM,\n  CENTER_BOTTOM,\n  RIGHT_BOTTOM,\n  getNestedElements } from '../helpers/positioning-helper'",
          "computed": true
        }, {
          "value": "import {\n  LEFT_TOP,\n  CENTER_TOP,\n  RIGHT_TOP,\n  LEFT_CENTER,\n  RIGHT_CENTER,\n  LEFT_BOTTOM,\n  CENTER_BOTTOM,\n  RIGHT_BOTTOM,\n  getNestedElements } from '../helpers/positioning-helper'",
          "computed": true
        }, {
          "value": "import {\n  LEFT_TOP,\n  CENTER_TOP,\n  RIGHT_TOP,\n  LEFT_CENTER,\n  RIGHT_CENTER,\n  LEFT_BOTTOM,\n  CENTER_BOTTOM,\n  RIGHT_BOTTOM,\n  getNestedElements } from '../helpers/positioning-helper'",
          "computed": true
        }, {
          "value": "import {\n  LEFT_TOP,\n  CENTER_TOP,\n  RIGHT_TOP,\n  LEFT_CENTER,\n  RIGHT_CENTER,\n  LEFT_BOTTOM,\n  CENTER_BOTTOM,\n  RIGHT_BOTTOM,\n  getNestedElements } from '../helpers/positioning-helper'",
          "computed": true
        }, {
          "value": "import {\n  LEFT_TOP,\n  CENTER_TOP,\n  RIGHT_TOP,\n  LEFT_CENTER,\n  RIGHT_CENTER,\n  LEFT_BOTTOM,\n  CENTER_BOTTOM,\n  RIGHT_BOTTOM,\n  getNestedElements } from '../helpers/positioning-helper'",
          "computed": true
        }]
      },
      "required": false,
      "description": "{const}\n One of:\n   @@Popup.POSITION_LEFT_TOP@@\n   @@Popup.POSITION_CENTER_TOP@@\n   @@Popup.POSITION_RIGHT_TOP@@\n   @@Popup.POSITION_LEFT_CENTER@@\n   @@Popup.POSITION_RIGHT_CENTER@@\n   @@Popup.POSITION_LEFT_BOTTOM@@\n   @@Popup.POSITION_CENTER_BOTTOM@@\n   @@Popup.POSITION_RIGHT_BOTTOM@@"
    },
    "children": {
      "type": {
        "name": "any"
      },
      "required": true,
      "description": "{---}\n Sequence of:\n   @@<Popup.Header>@@ (optional, max: 1),\n   @@<Popup.Content>@@ (required, max: 1),\n   @@<Popup.Footer>@@ (optional, max: 1)"
    },
    "fluid": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": ""
    },
    "useOver": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": ""
    },
    "open": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": ""
    },
    "target": {
      "type": {
        "name": "node"
      },
      "required": true,
      "description": ""
    },
    "onToggle": {
      "type": {
        "name": "func"
      },
      "required": true,
      "description": ""
    },
    "inverted": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": ""
    },
    "scrollable": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": ""
    },
    "small": {
      "type": {
        "name": "custom",
        "raw": "sizeProps"
      },
      "required": false,
      "description": "{bool} Mutually exclusive props: @@small@@ @@large@@"
    },
    "large": {
      "type": {
        "name": "custom",
        "raw": "sizeProps"
      },
      "required": false,
      "description": "{bool} Mutually exclusive props: @@small@@ @@large@@"
    }
  }
};